import { Grid } from '@mui/material';
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { vaBBBEEmodule } from "../../../../Component/Common/Constants/routes";
import { DataPageAccessRequests } from "./DataPageAccessRequests";
import { DataPageSubmissionStatus } from "../../../../Component/Model/Enum/BEE123Enums";
import { SimpleTab } from '../../../../Component/Common/Components/Tabs/SimpleTab';

export const DataPageAccessRequestBasePage = () => {
    const routes = [
      `/${vaBBBEEmodule.incoming}/${vaBBBEEmodule.accessRequests}/pending`,
      `/${vaBBBEEmodule.incoming}/${vaBBBEEmodule.accessRequests}/accepted`,
      `/${vaBBBEEmodule.incoming}/${vaBBBEEmodule.accessRequests}/rejected`,
    ]
  
    const labels = ['Pending', 'Accepted', 'Rejected'];
    const tabsData = routes.map((route, index) => ({
        route,
        label: labels[index]
    }));

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);
  
    const handleRedirect = () => {
      if (currentTabIndex === -1) {
        return <Redirect to={routes[0]} />;
      }
      return null;
    };
  
    return (
      <>
        <Grid container>
          <Grid item xs={12} mb={1}>
            <SimpleTab currentTab={currentTab} tabsData={tabsData}/>
          </Grid>
          <Grid item xs={12}>
            <Switch>
              {handleRedirect()}
              <Route path={routes[0]}>
                <DataPageAccessRequests status={DataPageSubmissionStatus.Pending} />
              </Route>
              <Route path={routes[1]}>
                <DataPageAccessRequests status={DataPageSubmissionStatus.Accepted} />
              </Route>
              <Route path={routes[2]}>
                <DataPageAccessRequests status={DataPageSubmissionStatus.Rejected} />
              </Route>
            </Switch>
          </Grid>
        </Grid>
      </>
    );
  }